const VISITOR_STATUS = {
  VISITING: 0, // 访问
  END_VISIT: 1, // 结束访问
  INVITING: 2, // 邀请中
  REJECT_INVITE: 3, // 拒绝邀请
  CONVERSE: 4, // 对话
  END_CONVERSE: 5, // 结束对话

  // 前台状态
  NO_RESPONSE: 6 // 未响应
};

export default VISITOR_STATUS;
